import { useQuery } from '@tanstack/react-query';
import {
  buildDefaultWellnessSiteContent,
  getPlacementSlides,
  getSiteCopy,
  type SiteCopyKey,
  type WellnessPlacementKey,
  type WellnessSiteContent,
} from '@lighthouse/shared';
import { api } from '../services/api';

export function useWellnessSite() {
  return useQuery({
    queryKey: ['wellness-site'],
    queryFn: () => api.get<WellnessSiteContent>('/site/wellness'),
    staleTime: 5 * 60_000,
    placeholderData: buildDefaultWellnessSiteContent(),
  });
}

export function useWellnessPlacement(placement: WellnessPlacementKey) {
  const { data } = useWellnessSite();
  return getPlacementSlides(data, placement);
}

export function useSiteCopyText(key: SiteCopyKey) {
  const { data } = useWellnessSite();
  return getSiteCopy(data, key);
}
